export const VARIATION_THEME_COLOUR = '#ED3D86';
